import React from 'react';
import {Step2Form} from '../../Forms';

export function Step2() {
	return <Step2Form />;
}
